// Supplier Database Structure
export const supplierCategories = {
  FARMERS_FOOD: 'farmers_food',
  CANDLES: 'candles',
  FRAGRANCES: 'fragrances',
  PACKAGING: 'packaging',
  DECORATIONS: 'decor',
  VENUES: 'venues',
  CATERING: 'catering',
  FLOWERS: 'flowers',
  POTTERY: 'pottery'
};

// Real Suppliers Database - Munich/Bavaria/Germany/Alps/Poland
export const suppliers = [
  // === FARMERS & LOCAL FOOD PRODUCERS (Bavaria/Alps) ===
  {
    id: 'sup-farm-001',
    name: 'Herrmannsdorfer Landwerkstätten',
    category: supplierCategories.FARMERS_FOOD,
    location: 'Glonn, Bavaria (40km from Munich)',
    type: 'Organic Farm & Butchery',
    specialties: ['Organic meats', 'Sausages', 'Cheese', 'Bread'],
    website: 'https://www.herrmannsdorfer.de',
    priceRange: '€€€',
    minOrder: '50€',
    deliveryTime: '2-3 days',
    notes: 'High-quality organic products, perfect for upscale events',
    contact: {
      phone: '+49 8093 90940',
      email: 'info@herrmannsdorfer.de'
    }
  },
  {
    id: 'sup-farm-002',
    name: 'Biomilch Bauern',
    category: supplierCategories.FARMERS_FOOD,
    location: 'Multiple locations Bavaria',
    type: 'Dairy Farmers Cooperative',
    specialties: ['Organic milk', 'Cheese', 'Butter', 'Yogurt'],
    website: 'https://www.biomilchbauern.de',
    priceRange: '€€',
    minOrder: '30€',
    deliveryTime: '1-2 days',
    notes: 'Great for dairy products, local Bavaria farmers'
  },
  {
    id: 'sup-farm-003',
    name: 'Alpenkäserei Allgäu',
    category: supplierCategories.FARMERS_FOOD,
    location: 'Allgäu, Alps (120km from Munich)',
    type: 'Alpine Cheese Dairy',
    specialties: ['Mountain cheese', 'Alpine cheese', 'Specialty cheeses'],
    website: 'https://www.alpenkaeserei.de',
    priceRange: '€€€',
    minOrder: '100€',
    deliveryTime: '3-5 days',
    notes: 'Premium Alps cheese, perfect for cheese platters'
  },
  {
    id: 'sup-farm-004',
    name: 'Isarland Ökokiste',
    category: supplierCategories.FARMERS_FOOD,
    location: 'Munich Region',
    type: 'Organic Box Delivery',
    specialties: ['Vegetables', 'Fruits', 'Eggs', 'Regional products'],
    website: 'https://www.isarland-oekokiste.de',
    priceRange: '€€',
    minOrder: '25€',
    deliveryTime: 'Next day',
    notes: 'Fresh vegetables and fruits, weekly delivery available'
  },

  // === CANDLES (AliExpress + Local) ===
  {
    id: 'sup-candle-001',
    name: 'AliExpress - Soy Wax Candles',
    category: supplierCategories.CANDLES,
    location: 'China (Ships to Germany)',
    type: 'Bulk Candle Supplier',
    specialties: ['Soy wax candles', 'Scented candles', 'Jar candles', 'Shaped candles'],
    website: 'https://www.aliexpress.com',
    priceRange: '€',
    minOrder: '10 pieces',
    deliveryTime: '15-30 days',
    notes: 'Cheap bulk candles, good for resale. Check ratings!',
    searchTerms: ['soy candles wholesale', 'scented candles bulk', 'luxury candles']
  },
  {
    id: 'sup-candle-002',
    name: 'Kerzen Herold',
    category: supplierCategories.CANDLES,
    location: 'Munich, Germany',
    type: 'Local Candle Shop',
    specialties: ['Handmade candles', 'Custom candles', 'Wedding candles'],
    website: 'https://www.kerzen-herold.de',
    priceRange: '€€€',
    minOrder: '50€',
    deliveryTime: '1-2 weeks (custom)',
    notes: 'High-quality German candles, custom orders available'
  },
  {
    id: 'sup-candle-003',
    name: 'Wenzel Kerzen',
    category: supplierCategories.CANDLES,
    location: 'Bavaria, Germany',
    type: 'Candle Manufacturer',
    specialties: ['Church candles', 'Event candles', 'Custom shapes'],
    website: 'https://www.wenzel-kerzen.de',
    priceRange: '€€',
    minOrder: '100€',
    deliveryTime: '1-2 weeks',
    notes: 'Wholesale candles, good for bulk events'
  },

  // === FRAGRANCES (Amazon - Real, not fake) ===
  {
    id: 'sup-frag-001',
    name: 'Amazon.de - Professional Fragrance Oils',
    category: supplierCategories.FRAGRANCES,
    location: 'Germany (Prime Shipping)',
    type: 'Online Marketplace',
    specialties: ['Essential oils', 'Fragrance oils', 'Perfume oils'],
    website: 'https://www.amazon.de',
    priceRange: '€€',
    minOrder: 'None',
    deliveryTime: '1-2 days (Prime)',
    notes: 'Verified sellers only! Brands: Mystic Moments, Naissance, Pajoma',
    recommendedBrands: [
      'Mystic Moments',
      'Naissance',
      'Pajoma Professional',
      'Sala Premium'
    ]
  },
  {
    id: 'sup-frag-002',
    name: 'Dragonspice',
    category: supplierCategories.FRAGRANCES,
    location: 'Germany',
    type: 'Essential Oil Supplier',
    specialties: ['Pure essential oils', 'Aromatherapy oils', 'Carrier oils'],
    website: 'https://www.dragonspice.de',
    priceRange: '€€',
    minOrder: '20€',
    deliveryTime: '2-3 days',
    notes: 'German supplier, high quality, certified organic options'
  },
  {
    id: 'sup-frag-003',
    name: 'Duft und Natur',
    category: supplierCategories.FRAGRANCES,
    location: 'Munich Region',
    type: 'Natural Fragrance Supplier',
    specialties: ['Natural fragrances', 'Custom blends', 'Event scents'],
    website: 'https://www.duftundnatur.de',
    priceRange: '€€€',
    minOrder: '50€',
    deliveryTime: '3-5 days',
    notes: 'Local Munich supplier, custom scent creation available'
  },

  // === PACKAGING & LABELS (AliExpress but Quality) ===
  {
    id: 'sup-pack-001',
    name: 'AliExpress - Premium Gift Boxes',
    category: supplierCategories.PACKAGING,
    location: 'China (Ships to Germany)',
    type: 'Packaging Supplier',
    specialties: ['Luxury gift boxes', 'Ribbon', 'Tissue paper', 'Labels'],
    website: 'https://www.aliexpress.com',
    priceRange: '€',
    minOrder: '50 pieces',
    deliveryTime: '20-40 days',
    notes: 'Look for "premium quality" sellers with high ratings. Check material specs!',
    searchTerms: ['luxury gift box', 'premium packaging', 'wedding favor boxes']
  },
  {
    id: 'sup-pack-002',
    name: 'Packari',
    category: supplierCategories.PACKAGING,
    location: 'Germany',
    type: 'Eco-Friendly Packaging',
    specialties: ['Sustainable packaging', 'Custom printing', 'Eco boxes'],
    website: 'https://www.packari.com',
    priceRange: '€€',
    minOrder: '100 pieces',
    deliveryTime: '1-2 weeks',
    notes: 'German company, sustainable options, custom branding available'
  },
  {
    id: 'sup-pack-003',
    name: 'Etikett.de',
    category: supplierCategories.PACKAGING,
    location: 'Germany',
    type: 'Label and Sticker Printer',
    specialties: ['Custom labels', 'Product stickers', 'Brand labels'],
    website: 'https://www.etikett.de',
    priceRange: '€€',
    minOrder: '250 pieces',
    deliveryTime: '5-7 days',
    notes: 'Professional label printing, good quality'
  },

  // === CATERING (Munich Small-Batch Production) ===
  {
    id: 'sup-cater-001',
    name: 'Käfer Feinkost',
    category: supplierCategories.CATERING,
    location: 'Munich',
    type: 'Gourmet Catering',
    specialties: ['Fine dining', 'Event catering', 'Gourmet products'],
    website: 'https://www.feinkost-kaefer.de',
    priceRange: '€€€€',
    minOrder: '500€',
    deliveryTime: '3-5 days notice',
    notes: 'Premium Munich caterer, perfect for high-end events'
  },
  {
    id: 'sup-cater-002',
    name: 'Königlicher Hirschgarten Catering',
    category: supplierCategories.CATERING,
    location: 'Munich',
    type: 'Traditional Bavarian Catering',
    specialties: ['Bavarian cuisine', 'Beer garden food', 'Event catering'],
    website: 'https://www.hirschgarten.de',
    priceRange: '€€€',
    minOrder: '300€',
    deliveryTime: '1 week notice',
    notes: 'Traditional Bavarian food, great for local events'
  },
  {
    id: 'sup-cater-003',
    name: 'Manufactum Brot & Butter',
    category: supplierCategories.CATERING,
    location: 'Munich',
    type: 'Artisan Bakery & Catering',
    specialties: ['Artisan bread', 'Pastries', 'Small catering'],
    website: 'https://www.manufactum.de',
    priceRange: '€€€',
    minOrder: '100€',
    deliveryTime: '2-3 days',
    notes: 'High-quality artisan products, small quantities possible'
  },

  // === FLOWERS (Local Munich) ===
  {
    id: 'sup-flower-001',
    name: 'Blumen Risse',
    category: supplierCategories.FLOWERS,
    location: 'Munich City Center',
    type: 'Florist & Event Flowers',
    specialties: ['Event florals', 'Wedding flowers', 'Fresh flowers'],
    website: 'https://www.blumen-risse.de',
    priceRange: '€€€',
    minOrder: '150€',
    deliveryTime: '3-5 days',
    notes: 'Established Munich florist, does event decoration'
  },
  {
    id: 'sup-flower-002',
    name: 'Tollwood Blumenmarkt',
    category: supplierCategories.FLOWERS,
    location: 'Munich (Seasonal)',
    type: 'Flower Market',
    specialties: ['Seasonal flowers', 'Local flowers', 'Affordable bulk'],
    website: 'https://www.tollwood.de',
    priceRange: '€€',
    minOrder: 'None',
    deliveryTime: 'Same day (at market)',
    notes: 'Seasonal market, great prices for bulk buying'
  },

  // === DECORATIONS (Local + Poland option) ===
  {
    id: 'sup-decor-001',
    name: 'Deko-Fabrik München',
    category: supplierCategories.DECORATIONS,
    location: 'Munich',
    type: 'Event Decoration Supplier',
    specialties: ['Event decor', 'Table decorations', 'Party supplies'],
    website: 'https://www.deko-fabrik-muenchen.de',
    priceRange: '€€',
    minOrder: '50€',
    deliveryTime: '1-2 days',
    notes: 'Local Munich supplier, good for same-day needs'
  },
  {
    id: 'sup-decor-002',
    name: 'Poland Decoration Suppliers',
    category: supplierCategories.DECORATIONS,
    location: 'Poland (Near German Border)',
    type: 'Wholesale Decoration',
    specialties: ['Bulk decorations', 'Affordable decor', 'Event supplies'],
    website: 'Various',
    priceRange: '€',
    minOrder: '200€',
    deliveryTime: '5-7 days',
    notes: 'Cheaper option, worth the trip for bulk orders. Cities: Wrocław, Poznań'
  },

  // === VENUES (Munich & Bavaria) ===
  {
    id: 'sup-venue-001',
    name: 'Alte Utting',
    category: supplierCategories.VENUES,
    location: 'Munich',
    type: 'Unique Event Space',
    specialties: ['Urban events', 'Creative space', 'Outdoor deck'],
    website: 'https://www.alte-utting.de',
    priceRange: '€€€',
    capacity: '50-200 people',
    notes: 'Trendy Munich venue, boat on a bridge'
  },
  {
    id: 'sup-venue-002',
    name: 'Gut Kaltenbrunn',
    category: supplierCategories.VENUES,
    location: 'Tegernsee, Bavaria (60km)',
    type: 'Luxury Country Estate',
    specialties: ['Weddings', 'Corporate events', 'Luxury events'],
    website: 'https://www.gut-kaltenbrunn.de',
    priceRange: '€€€€',
    capacity: '50-300 people',
    notes: 'Premium venue in the Alps'
  },
  {
    id: 'sup-venue-003',
    name: 'Isarlust',
    category: supplierCategories.VENUES,
    location: 'Munich (Isar River)',
    type: 'Beach Bar & Event Space',
    specialties: ['Summer events', 'Casual events', 'Outdoor space'],
    website: 'https://www.isarlust.de',
    priceRange: '€€',
    capacity: '50-150 people',
    notes: 'Casual Munich venue, beach vibe'
  },

  // === POTTERY & CERAMIC (Local Workshops) ===
  {
    id: 'sup-pottery-001',
    name: 'Keramik Werkstatt München',
    category: supplierCategories.POTTERY,
    location: 'Munich',
    type: 'Ceramic Workshop',
    specialties: ['Handmade pottery', 'Custom ceramics', 'Small batches'],
    website: 'https://www.keramik-muenchen.de',
    priceRange: '€€€',
    minOrder: '100€',
    deliveryTime: '2-4 weeks',
    notes: 'Local artisan, custom orders possible'
  }
];

// Pricing calculation helper
export function calculateProductPrice(costBreakdown, targetMargin = 0.40) {
  const totalCost = Object.values(costBreakdown).reduce((sum, cost) => sum + cost, 0);
  const sellingPrice = totalCost / (1 - targetMargin);
  const profit = sellingPrice - totalCost;

  return {
    totalCost: totalCost.toFixed(2),
    targetMargin: (targetMargin * 100).toFixed(0) + '%',
    sellingPrice: sellingPrice.toFixed(2),
    profit: profit.toFixed(2),
    profitMargin: ((profit / sellingPrice) * 100).toFixed(1) + '%'
  };
}

// Example cost breakdown structure
export const exampleCostBreakdown = {
  materials: 5.50,        // Candle wax, wick, etc.
  packaging: 2.00,        // Box, label, tissue paper
  fragrance: 3.00,        // Essential oil
  labor: 4.00,            // Your time
  shipping: 2.50,         // Delivery to customer
  overhead: 1.00          // Utilities, storage, etc.
};

// Calculate: const pricing = calculateProductPrice(exampleCostBreakdown, 0.40);
// Result: Total cost €18, Sell for €30, Profit €12 (40% margin)
